import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ProvingVehiclesQueryVariables = {
  filter?: Types.Maybe<Types.ProvingFilterType>
};


export type ProvingVehiclesQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id' | 'id' | 'title'>
    & { vehicles: Types.Maybe<Array<(
      { __typename?: 'InternalVehicle' }
      & Pick<Types.InternalVehicle, 'internalNumberUnknown' | 'label' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin'>
      & { eqVehicle: Types.Maybe<(
        { __typename?: 'EQVehicle' }
        & Pick<Types.EqVehicle, '_id' | 'id' | 'internalLabel' | 'label' | 'licensePlate' | 'vin' | 'type' | 'typeDescription' | 'derivative'>
      )>, transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    ) | (
      { __typename?: 'ExternalVehicle' }
      & Pick<Types.ExternalVehicle, 'labelExternal' | 'type' | 'unknown' | 'dateTo' | 'dateFrom' | 'orderId' | 'model' | 'licensePlate' | 'licensePlateType' | 'vin'>
      & { transport: Types.Maybe<(
        { __typename?: 'Transport' }
        & Pick<Types.Transport, 'transportType' | 'bookingStatus'>
      )> }
    )>> }
  )> }
);

export const ProvingVehiclesDocument = gql`
    query ProvingVehicles($filter: ProvingFilterType) {
  provings(filter: $filter) {
    _id
    id
    title
    vehicles {
      type
      unknown
      dateTo
      dateFrom
      orderId
      transport {
        transportType
        bookingStatus
      }
      model
      licensePlate
      licensePlateType
      vin
      ... on InternalVehicle {
        internalNumberUnknown
        eqVehicle {
          _id
          id
          internalLabel
          label
          licensePlate
          vin
          type
          typeDescription
          derivative
        }
        label
      }
      ... on ExternalVehicle {
        labelExternal
      }
    }
  }
}
    `;

    export function useProvingVehiclesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvingVehiclesQuery, ProvingVehiclesQueryVariables>) {
      return ApolloReactHooks.useQuery<ProvingVehiclesQuery, ProvingVehiclesQueryVariables>(ProvingVehiclesDocument, baseOptions);
    };
      export function useProvingVehiclesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvingVehiclesQuery, ProvingVehiclesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ProvingVehiclesQuery, ProvingVehiclesQueryVariables>(ProvingVehiclesDocument, baseOptions);
      };
      
export type ProvingVehiclesQueryHookResult = ReturnType<typeof useProvingVehiclesQuery>;
export type ProvingVehiclesQueryResult = ApolloReactCommon.QueryResult<ProvingVehiclesQuery, ProvingVehiclesQueryVariables>;